import { Box, Button, CardMedia, Dialog, DialogActions, DialogContent, Grid, IconButton, InputAdornment, Skeleton, Theme, ToggleButtonGroup, ToggleButton, Typography, useTheme, Menu, MenuItem, Radio, ClickAwayListener, Tooltip, SelectChangeEvent } from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory, useRouteMatch } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import * as yup from 'yup';
import { Formik, FormikProps, FormikContextType, setNestedObjectValues, useFormikContext, FormikValues, FormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  sendOtp,
  verifyPan,
  EnablePOA,
  IsApplicableForPOA,
  SendEmail,
  AcknowledgeAmlCheck,
  sendConsentEmail,
  getApplicationTypes,
  physicalOnboarding,
} from '../../redux-store/actions/onBoarding';
import {
  AcknowledgeAmlCheckResponseBody,
  AmlSystemMatch,
  ApplicationProps,
  CreateApplicationProps,
  EnablePOAResponseBody,
  IsApplicableForPOAResponseBody,
  SendConsentEmailResponseBody,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
  VerifyPanResponseBody,
} from '../../redux-store/types/api-types';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import {
  emailRegex,
  individualPanRegex,
  nameWithNumberRegex,
  nonIndividualPanRegex,
  phoneRegExp,
} from '../../utils/regex';
import { Location } from 'history';
import { Notes } from '../investors/components';
import MFCheckbox from '../../lib/formik/Checkbox';

// import { DatePicker } from '../../lib/formik/DatePicker';
import { TextDatePicker } from './DatePickerWithTextFeild';
import { INDIVIDUAL_ONBOARDING_CHAR_LIMIT, MINOR_ONBOARDING_CHAR_LIMIT, minorOnboardingSubTypes, yearfor156years } from '../../utils/constant';

import {
  futureAge,
  getCountryCodes,
  getDateValidation,
  getUniqueIdentityText,
  isMinor,
  isOnboardingTypeMinor,
  maxAge,
  preventSpecialCharacters,
  todaysdate,
} from '../../utils/utilityFunctions';
import {
  APPLICATION_TYPE,
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  IS_DOB_APPLICABLE_FOR_AMC,
  ONBOARDING_KYC_VERIFIED_MESSAGE,
  ONBOARDING_OPTIONS,
  ONBOARDING_SUB_TYPE_NON_INDIVIDUAL,
  ONBOARDING_SUB_TYPE_MINOR,
  ONBOARDING_VIA_OPTIONS,
  PHYSICAL_DIGITAL_FLOW,
  USER_ROLES,
  ONBOARDING_TYPE_MAPPER,
  fundTypes,
  personLDetailsStatusMasters,
  investorTypeMasters,
  eighteenYearsAgoDate,
  yearfor125years
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { AmlPopup, AmlPopupValues, CountryCodesDropDown } from '../commonComponents';
import { Link as RouterLink } from 'react-router-dom';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import 'react-datepicker/dist/react-datepicker.css';
import { DayJsDatePicker } from './newDatePicker';
import dayjs from 'dayjs';
import PersonIcon from '../../assets/icons/PersonIcon';
import GroupIcon from '../../assets/icons/GroupIcon';
import TickIcon from '../../assets/icons/TickIcon';
import { InfoIconOutlined } from '../../assets/SvgIcons';
import CompanyIcon from '../../assets/icons/CompanyIcon';
import { showError } from '../../redux-store/actions/auth';
import { LoadingButton } from '@mui/lab';
import { getFormattedISTDate, getFormattedISTDateString } from '../../utils/date';
import MFSelectField from '../../lib/formik/SelectField';

interface Values {
  pan: string;
  dob: string;
  onboardingType: string;
  onboardingSubType?: string;
  isBSEEnabled: boolean;
  onboardingVia?: string;
  countryNameAndCode?: string;
  kycMethod: {
    selectedValue: string;
    isOsvOpen: boolean;
  }
  name: string;
  emailId: string;
  mobile: string;
  minorName?: string;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
  accountType: string;
}
interface EValues {
  pan: string;
  emailId: string;
  mobile: string;
  countryNameAndCode: string;
  dob: string;
  accountType: string;
}

interface InvestorTypeProps {
  value: string;
  label: string;
  isDisabled: boolean;
  activeType: string;
  handleClick: Dispatch<SetStateAction<string>>
}

const onboardingTypes: Array<{ label: string; value: string; }> = [
  {
    label: "Individual",
    value: 'individual'
  },
  {
    label: "Non Individual",
    value: "nonIndividual"
  },
  {
    label: "Minor",
    value: "minor"
  },
]


function InvestorType({
  value,
  label,
  isDisabled,
  activeType,
  handleClick
}: InvestorTypeProps) {

  const theme = useTheme()

  const activeStyle = {
    borderWidth: "1px",
    borderColor: "primary.500",
    backgroundColor: `${theme.palette.primary[500]}1A`,
    cursor: 'pointer'
  }

  const inActiveStyle = {
    borderWidth: "0.5px",
    borderColor: "text.secondary",
    backgroundColor: `${theme.palette.background.paper}0D`,
    cursor: 'pointer'
  }

  const disabledStyle = {
    borderWidth: "1px",
    borderColor: "primary.100",
    backgroundColor: "grey.50",
    cursor: 'not-allowed'
  }

  const styleObj: any = {
    currentStyle: null,
    fillColor: null,
    strokeColor: null,
    textColor: null
  }

  if (isDisabled) {
    styleObj.currentStyle = disabledStyle
    styleObj.fillColor = theme.palette.primary[200]
    styleObj.textColor = theme.palette.primary[200]
    styleObj.strokeColor = theme.palette.primary[200]
  } else if (activeType === value) {
    styleObj.currentStyle = activeStyle
    styleObj.fillColor = theme.palette.primary[500]
    styleObj.textColor = theme.palette.primary[500]
    styleObj.strokeColor = theme.palette.primary[500]
  } else {
    styleObj.currentStyle = inActiveStyle
    styleObj.strokeColor = theme.palette.text.secondary
    styleObj.textColor = theme.palette.text.secondary
  }

  const iconsObj: Record<string, JSX.Element> = {
    individual: <PersonIcon
      fillColor={styleObj.fillColor}
      strokeColor={styleObj.strokeColor}
    />,
    minor: <GroupIcon
      fillColor={styleObj.fillColor}
      strokeColor={styleObj.strokeColor}
    />,
    nonIndividual: <CompanyIcon
      strokeColor={styleObj.strokeColor}
    />,
  }


  return (
    <Box
      onClick={() => {
        if (isDisabled) return

        handleClick(value)
      }}
      sx={{
        borderRadius: "15px",
        px: (value === "normal" ? "20px" : "33px"),
        py: (activeType === value ? "25.5px" : "26px"),
        borderStyle: "solid",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        rowGap: "5px",
        ...styleObj.currentStyle
      }}>
      {iconsObj[value]}
      <Typography variant='body_500' color={styleObj.textColor}>{label}</Typography>
    </ Box>
  )
}

export function KycOsvSection({
  // setVerifyPanApiCalled,
  disabled,
  setPanVerificationToken
}: {
  // setVerifyPanApiCalled: Dispatch<SetStateAction<boolean>>;
  disabled: string | null;
  setPanVerificationToken: Dispatch<SetStateAction<string>>
}): JSX.Element {

  const { values, setFieldValue }: FormikContextType<Values> = useFormikContext()
  const theme = useTheme();

  const activeStyle = {
    borderWidth: "1px",
    borderColor: "primary.500",
    backgroundColor: `${theme.palette.primary[500]}1A`,
    cursor: 'pointer'
  }

  const inActiveStyle = {
    borderWidth: "0.5px",
    borderColor: "text.secondary",
    backgroundColor: `${theme.palette.background.paper}0D`,
    cursor: 'pointer'
  }

  const getStyleObj = (method: string) => {
    const styleObj = {
      currentStyle: {},
      fillColor: 'string',
      strokeColor: 'string',
      textColor: 'string',
      backgroundColor: 'string'
    };

    if (values.kycMethod.selectedValue !== method) {
      styleObj.currentStyle = inActiveStyle;
      styleObj.strokeColor = theme.palette.text.secondary;
      styleObj.textColor = theme.palette.text.secondary;
    } else {
      styleObj.currentStyle = activeStyle;
      styleObj.backgroundColor = `${theme.palette.primary}`;
      styleObj.textColor = `${theme.palette.primary[500]}`;
    }

    return styleObj;
  };
  if (disabled) {
    useEffect(() => {
      setFieldValue('kycMethod.isOsvOpen', disabled === 'osv' ? true : false);
      setFieldValue('kycMethod.selectedValue', disabled === 'osv' ? 'osv' : 'investor');
    }, [disabled, setFieldValue]);

    return (
      <Grid sx={{ display: 'flex', xs: { flexDirection: 'column' }, position: 'relative', alignItems: 'center', maxWidth: 'max-content' }}>
        <Grid mr={5} sx={{ display: 'flex', flexWrap: 'wrap', zIndex: 5, gap: '15px' }}>
          <Box
            sx={{
              borderRadius: "15px",
              px: "10px",
              py: "10px",
              borderStyle: "solid",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              rowGap: "5px",
              ...activeStyle
            }}>
            <Radio
              size='small'
              checked={true}
              sx={{
                '&.MuiRadio-sizeSmall': {
                  padding: '0px',

                },
                color: theme.palette.primary[500],
                '& .MuiSvgIcon-root': {
                  fontSize: theme.typography.subtitle_400,
                },
              }}
            />
            <Typography
              variant='subtitle_600'
              sx={{ fontWeight: '500', ml: '10px' }}
              color={getStyleObj("osv").textColor}>
              {disabled === 'osv' ? 'OSV Document Upload' : 'KYC Verification by Investor'}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    )
  }

  const handleShowOSV = (boolVal: boolean) => {
    setFieldValue('kycMethod.isOsvOpen', boolVal)
  }

  const handleClickAway = () => {
    if (values.kycMethod.isOsvOpen && values.kycMethod.selectedValue === 'investor') {
      handleShowOSV(false);
    }
  };

  const handleMethodChange = (method: string) => {
    setFieldValue('kycMethod.selectedValue', method);
    if (method === 'investor') {
      handleShowOSV(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Grid sx={{ display: 'flex', xs: { flexDirection: 'column' }, position: 'relative', alignItems: 'center', maxWidth: 'max-content' }}>
        <Grid mr={5} sx={{ display: 'flex', flexWrap: 'wrap', zIndex: 5, gap: '15px' }}>
          <Box
            onClick={() => { handleMethodChange("investor"); }}
            sx={{
              borderRadius: "15px",
              px: "8px",
              py: "13px",
              borderStyle: "solid",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              ...getStyleObj("investor").currentStyle,
            }}>
            <Radio
              size='small'
              checked={values.kycMethod.selectedValue === "investor"}
              sx={{
                '&.MuiRadio-sizeSmall': {
                  padding: '0px',

                },
                color: theme.palette.primary[500],
                '& .MuiSvgIcon-root': {
                  fontSize: theme.typography.subtitle_400,
                },
              }}
            />
            <Typography
              variant='subtitle_600'
              sx={{ fontWeight: '500', ml: '10px' }}
              color={getStyleObj("investor").textColor}>
              KYC Verification by Investor
            </Typography>
          </Box>

          {values.kycMethod.isOsvOpen && (
            <Box
              onClick={() => { handleMethodChange("osv"); }}
              sx={{
                borderRadius: "15px",
                px: "10px",
                py: "10px",
                borderStyle: "solid",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                rowGap: "5px",
                ...getStyleObj("osv").currentStyle
              }}>
              <Radio
                size='small'
                checked={values.kycMethod.selectedValue === "osv"}
                sx={{
                  '&.MuiRadio-sizeSmall': {
                    padding: '0px',

                  },
                  color: theme.palette.primary[500],
                  '& .MuiSvgIcon-root': {
                    fontSize: theme.typography.subtitle_400,
                  },
                }}
              />
              <Typography
                variant='subtitle_600'
                sx={{ fontWeight: '500', ml: '10px' }}
                color={getStyleObj("osv").textColor}>
                OSV Document Upload
              </Typography>
            </Box>
           )} 
        </Grid>

        {!values.kycMethod.isOsvOpen && (
          <Box sx={{ position: 'absolute', right: 0 }}>
            <IconButton
              onClick={() => handleShowOSV(true)}
              size="small"
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        )}
      </Grid>
    </ClickAwayListener>
  );
}

export function VerifyPanAadharAmlKycSection({ verifyPanApiCalled, onboardingType, checkStatus }: { verifyPanApiCalled: any; onboardingType: string; checkStatus: { amlCheck: boolean; ckycCheck: boolean; panAddharCheck: boolean; kraCheck: boolean } }): JSX.Element | null {
  if (!verifyPanApiCalled) return null
  const { values } = useFormikContext() as FormikProps<FormikValues>;
  const theme = useTheme();
  const statuses: string[] = `${onboardingType ?? ''}` === 'nonIndividual'
    ? ["PAN Aadhaar Linked", "KYC Verified by KRA Link"]
    : ["PAN Aadhaar Linked", "KYC Verified by KRA Link"];
  return (
    <Box display="flex" gap='14px' mb={2} flexWrap="wrap">
      {verifyPanApiCalled && statuses.map((status, index) => (
        <Box
          key={index}
          sx={(theme: Theme) => ({
            display: "flex",
            alignItems: "center",
            gap: '4px',
            px: '10px',
            py: '8.5px',
            borderRadius: '10px',
            bgcolor: getStatusColor(status, checkStatus, theme)
          })}
        >
          {getStatusIcon(status, checkStatus)}
          <Typography variant="subtitle_600" sx={{ fontWeight: 500 }} color="text.primary">
            {status}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

const getStatusColor = (status: string, checkStatus: { amlCheck: boolean; ckycCheck: boolean; panAddharCheck: boolean; kraCheck: boolean }, theme: Theme) => {
  switch (status) {
    case "PAN Aadhaar Linked":
      return checkStatus.panAddharCheck ? theme.palette.customColors.offGreen : theme.palette.error[50];
    case "AML Verification":
      return checkStatus.amlCheck ? theme.palette.customColors.offGreen : theme.palette.error[50];
    case "KYC Verified by KRA Link":
      return checkStatus.kraCheck ? theme.palette.customColors.offGreen : theme.palette.error[50];
    case "CKYC Available":
      return checkStatus?.ckycCheck ? theme.palette.customColors.offGreen : theme.palette.error[50];
    default:
      return theme.palette.error[50];
  }
}

const getStatusIcon = (status: string, checkStatus: { amlCheck: boolean; ckycCheck: boolean; panAddharCheck: boolean; kraCheck: boolean }) => {
  switch (status) {
    case "PAN Aadhaar Linked":
      return checkStatus.panAddharCheck ? <DoneIcon sx={(theme: Theme) => ({ color: theme.palette.customColors.greenTeal, fontSize: theme.typography.subtitle_400 })} /> : <CloseIcon sx={(theme: Theme) => ({ color: theme.palette.error[500], fontSize: theme.typography.subtitle_400 })} />;
    case "AML Verification":
      return checkStatus.amlCheck ? <DoneIcon sx={(theme: Theme) => ({ color: theme.palette.customColors.greenTeal, fontSize: theme.typography.subtitle_400 })} /> : <CloseIcon sx={(theme: Theme) => ({ color: theme.palette.error[500], fontSize: theme.typography.subtitle_400 })} />;
    case "KYC Verified by KRA Link":
      return checkStatus.kraCheck ? <DoneIcon sx={(theme: Theme) => ({ color: theme.palette.customColors.greenTeal, fontSize: theme.typography.subtitle_400 })} /> : <CloseIcon sx={(theme: Theme) => ({ color: theme.palette.error[500], fontSize: theme.typography.subtitle_400 })} />;
    case "CKYC Available":
      return checkStatus.ckycCheck ? <DoneIcon sx={(theme: Theme) => ({ color: theme.palette.customColors.greenTeal, fontSize: theme.typography.subtitle_400 })} /> : <CloseIcon sx={(theme: Theme) => ({ color: theme.palette.error[500], fontSize: theme.typography.subtitle_400 })} />;
    default:
      return <CloseIcon />;
  }
}

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
  }>;
}): JSX.Element {
  const formikRef = useRef<FormikProps<Values>>(null);

  const { path: currentPathName } = useRouteMatch();
  const { redirectTo = '', firstHolderName = '', application } = location.state || {};
  const { id, applicants = [], hasPOA, onboardingVia } = application || {};
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [amlPopup, setAmlPopup] = React.useState<{
    panVerificationToken: string;
    pan: string;
    dob: string;
  } | null>(null);
  const [amlFailedresponse, setAmlFailedresponse] = React.useState<AmlSystemMatch>();
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);
  const [amlCheckPassed, setAmlCheckPassed] = useState(false)
  const [verifyPanApiCalled, setVerifyPanApiCalled] = useState(false);
  const [panVerificationToken, setpanVerificationToken] = useState('');
  const [createOnboarding, setCreateOnboarding] = useState(false);
  const [panVerificationResponse, setPanVerificationResponse] = useState<VerifyPanResponseBody>();
  const [kraPopup, setKraPopup] = React.useState<boolean>(false);

  const currentDate = dayjs();

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-pan-number'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')
  const showRadioGroup = (id && redirectTo) ? onboardingVia === 'physical' : true

  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);
  const [applicationTypes, setApplicationTypes] = useState<{
    code: string;
    description: string;
  }[]>([])
  const [isApplicationTypesLoading, setApplicationTypesLoading] = useState<boolean>(false)
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  const theme = useTheme();
  useEffect(() => {
    const fetchApplicationTypes = async () => {
      if (isInvestorDiyOnboarding || isDiyJointHolder) {
        return
      }

      try {
        setApplicationTypesLoading(true)

        const response = await (dispatch(getApplicationTypes()) as unknown as Promise<{ code: string; description: string }[]>)

        setApplicationTypes(response ?? [])
      } catch (error) {
        console.log(error)
      } finally {
        setApplicationTypesLoading(false)
      }
    }

    // fetchApplicationTypes()
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  const validationSchema1 = yup.object().shape({
    onboardingType: yup.string().required(),
    name: yup.string().required('Full Name is required').matches(nameWithNumberRegex, 'Special Characters except .\'-()& not allowed')
      .test('max-length', (value, context) => {
        const fieldValue = value ?? ""
        const { path, createError, parent } = context;
        if (isOnboardingTypeMinor(parent?.onboardingType ?? "")) {
          if (`${fieldValue}`.length > MINOR_ONBOARDING_CHAR_LIMIT.PERSONAL_DETAILS.GUARDIAN_FULL_NAME) {
            return createError({
              message: `Guardian Full Name should not be greater than ${MINOR_ONBOARDING_CHAR_LIMIT.PERSONAL_DETAILS.GUARDIAN_FULL_NAME} characters`,
              path,
            });
          }
        } else {
          if (`${fieldValue}`.length > INDIVIDUAL_ONBOARDING_CHAR_LIMIT.PERSONAL_DETAILS.FULL_NAME) {
            return createError({
              message: `Full Name should not be greater than ${INDIVIDUAL_ONBOARDING_CHAR_LIMIT.PERSONAL_DETAILS.FULL_NAME} characters`,
              path,
            });
          }
        }

        return true
      }),
    minorName: yup.string().when('onboardingType', {
      is: 'minor',
      then: yup.string().required('Minor Full Name is required').matches(nameWithNumberRegex, 'Special Characters except .\'-()& not allowed')
        .test('max-length', (value, context) => {
          const fieldValue = value ?? "";
          const { path, createError, parent } = context;
          if (`${fieldValue}`.length > MINOR_ONBOARDING_CHAR_LIMIT.PERSONAL_DETAILS.MINOR_FULL_NAME) {
            return createError({
              message: `Minor Full Name should not be greater than ${MINOR_ONBOARDING_CHAR_LIMIT.PERSONAL_DETAILS.MINOR_FULL_NAME} characters`,
              path,
            });
          }
          return true;
        }),
    }),
    pan: yup.string().uppercase()
      // .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }
        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (
            (
              parent?.onboardingType === "individual" ||
              parent?.onboardingType === "minor" ||
              parent?.onboardingSubType === 'SOLEPROP'
            ) &&
            !individualPanRegex.test(fieldValue)
          ) {
            return createError({
              message: 'Only Individual PANs are allowed',
              path,
            });
          }

          if (
            parent?.onboardingType === "nonIndividual" && parent.onboardingSubType !== 'SOLEPROP' &&
            (
              // To check whether the entered PAN is individual
              individualPanRegex.test(fieldValue) ||
              // To check the format for PAN entered
              !nonIndividualPanRegex.test(fieldValue)
            )
          ) {
            return createError({
              message: 'Only Non Individual PANs are allowed',
              path,
            });
          }
        }

        // if (!individualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'Only individual PANs are allowed',
        //     path,
        //   });
        // }
        // if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'invalid PAN',
        //     path,
        //   });
        // }
        // if (!nonIndividualPanRegex.test(fieldValue)) {
        //   return createError({
        //     message: 'invalid PAN',
        //     path,
        //   });
        // }
        if (fieldValue.split('')[3] === 'P' && applicantPanNumbers.includes(fieldValue)) {
          return createError({
            message: 'There is already same pan for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    dob: yup.string().nullable().test('dob', (value, context) => {
      const fieldValue = value === undefined ? '' : value;
      const { path, createError, parent } = context;
      const { isBeforeLimit: limit125yrsBefore, } = getDateValidation({ date: fieldValue ?? '', limitValue: yearfor125years });
      const { isBeforeLimit: limit156yrsBefore, } = getDateValidation({ date: fieldValue ?? '', limitValue: yearfor156years });
      const { isAfterLimit: limit18yrsAfter } = getDateValidation({ date: fieldValue ?? '', limitValue: eighteenYearsAgoDate });

      if (IS_DOB_APPLICABLE_FOR_AMC) {
        if (!fieldValue) {
          return createError({
            message: 'Date of Birth is required',
            path,
          });
        }
        const date = new Date(fieldValue);

        if (isNaN(date.getTime())) {
          return createError({ path, message: 'Invalid Date format' });
        }
        if (futureAge(fieldValue || '')) {
          return createError({
            message: 'Future date of birth is not allowed',
            path,
          });
        }
        if ((limit125yrsBefore) && parent.pan?.split('')[3] === 'P') {
          return createError({
            message: 'Age should be less than 125 years',
            path,
          });
        }
        if ((limit18yrsAfter) && parent.pan?.split('')[3] === 'P') {
          return createError({
            message: 'Age should be greater than 18 years',
            path,
          });
        }
        //This works for non-individual allows 156 years before
        if (limit156yrsBefore && parent.pan?.split('')[3] !== 'P') {
          return createError({
            message: 'Age should be less than 156 years',
            path,
          });
        }
      }

      return true;
    }),
    emailId: yup
      .string()
      .nullable()
      .matches(emailRegex, 'invalid Email ID')
      .required('Email is required'),
    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => !value,
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => !value,
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
  });

  const initialValues1: Values = {
    pan: '',
    dob: '',
    onboardingType: 'individual',
    onboardingSubType: 'Individual',
    countryNameAndCode: 'India: +91',
    isBSEEnabled: application?.isBSEEnabled ?? true,
    // ...(PHYSICAL_DIGITAL_FLOW ? { onboardingVia: id ? onboardingVia : 'physical' } : {}),
    onboardingVia: id ? onboardingVia : 'digital',
    kycMethod: {
      selectedValue: "investor",
      isOsvOpen: false
    },
    name: '',
    minorName: '',
    mobile: '',
    emailId: '',
  };

  const routingAfterPanVerification = async (
    response: VerifyPanResponseBody | AcknowledgeAmlCheckResponseBody,
    pan: string,
    dob: string,
    onboardingVia?: string,
  ) => {
    if (hasPOA) {
      const { panVerificationToken } = response || {};
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await dispatch(addJointHolder({ applicantVerificationToken }, id));
      history.push(redirectTo, { id });
      return;
    }
    if (response.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL || onboardingVia === "physical") {
      return history.push('enter-email-id', {
        pan: pan.toUpperCase(),
        dob: dob,
        onboardingVia: onboardingVia,
        ...(response || {}),
        application,
        redirectTo,
        onboardingType: response?.applicationType
      });
    }
    history.push('enter-mobile-number', {
      pan: pan.toUpperCase(),
      dob: dob,
      ...(response || {}),
      redirectTo,
      firstHolderName,
      application,
    });
  };
  const handleKraPopupClose = () => {
    setKraPopup(false);
  };

  const onKraSubmit = async () => {
    try {
      setAmlAcknowledgementLoading(true);
      setKraPopup(false);
      setpanVerificationToken(panVerificationResponse?.panVerificationToken ?? '');
      setVerifyPanApiCalled(true)

    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  };

  const handleVerifyPan = async (values: Values) => {
    try {
      if (!formikRef.current) {
        return
      }
      if (!formikRef.current?.values?.onboardingSubType) {
        dispatch(showError('Please select Sub Onboarding Type'))
      }
      setAmlAcknowledgementLoading(true);
      const { setTouched } = formikRef.current
      const errorsObj = await setTouched({
        pan: true,
        name: true,
        dob: true,
        minorName: true
      }, true) ?? {}
      if (
        Object.keys(errorsObj)
          .filter(key => ['pan', 'name', 'dob', 'minorName']
            .includes(key)).some(key => key in errorsObj)
      ) {
        return
      }

      const {
        pan,
        dob,
        onboardingType,
        onboardingVia,
        name,
        kycMethod,
        onboardingSubType,
        isBSEEnabled,
        minorName
      } = values;

      const response = (await dispatch(
        verifyPan({
          pan,
          dob: getFormattedISTDate(dob) ?? dob,
          onboardingType: ((onboardingType === "individual") || (onboardingType === "nonIndividual")) ? "normal" : "minor",
          onboardingVia: onboardingVia,
          name,
          onboardingSubType: onboardingSubType || (onboardingType === "individual" ? "Individual" : 'corporate'),
          isBSEEnabled,
          onboardingApplicationType: ONBOARDING_TYPE_MAPPER[onboardingType],
          minorName: minorName ?? '',
        }, false)
      )) as unknown as VerifyPanResponseBody

      if (!response) return;

      setPanVerificationResponse(response);
      setAmlCheckPassed(response.amlCheck);
      if (!isBSEEnabled) formikRef.current.setFieldValue('name', response.name);

      if (isBSEEnabled && !response.kraCheck) {
        setKraPopup(true);
        return;
      }

      setpanVerificationToken(response.panVerificationToken);
      setVerifyPanApiCalled(true);

      // if (!response.amlCheck) {
      //   setAmlFailedresponse(response.amlData.system_match[0]);
      //   return setAmlPopup({
      //     panVerificationToken: response.panVerificationToken,
      //     pan: pan,
      //     dob: dob,
      //   });
      // }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setAmlAcknowledgementLoading(false);
    }
  }

  const handleFundTypeChange = (value: string) => {
    if (!formikRef.current) {
      return
    }

    const { setFieldValue } = formikRef.current;
    setVerifyPanApiCalled(false);
    setFieldValue("isBSEEnabled", value === "true")
  }

  // const handleSubmit1 = async (values: Values) => {
  //   setAmlAcknowledgementLoading(true);
  //   try {
  //     const {
  //       pan,
  //       dob,
  //       onboardingType,
  //       onboardingVia,
  //     } = values;
  //     const response = (await dispatch(
  //       verifyPan({ pan, dob, onboardingType: ((onboardingType === "individual") || (onboardingType === "nonIndividual")) ? "normal" : "minor", onboardingVia: onboardingVia, }, false)
  //     )) as unknown as VerifyPanResponseBody


  //     if (!response) return

  //     if (!response.amlCheck) {
  //       setAmlFailedresponse(response.amlData.system_match[0]);
  //       return setAmlPopup({
  //         panVerificationToken: response.panVerificationToken,
  //         pan: pan,
  //         dob: dob,
  //       });
  //     }
  //     if ((isInvestorDiyOnboarding || isDiyJointHolder)) {
  //       routingAfterPanVerification(response, pan, dob);
  //     }
  //     else {
  //       routingAfterPanVerification(response, pan, dob, onboardingVia);
  //     }
  //   } catch (e) {
  //     console.error((e as Error).message);
  //   } finally {
  //     setAmlAcknowledgementLoading(false);
  //   }
  // };

  const handleSubmit1 = async (values: Values) => {
    setCreateOnboarding(true);
    const { countryNameAndCode = '', dob = '', emailId = '', name = '', kycMethod = { selectedValue: '', isOsvOpen: false }, mobile = '', onboardingType = '', onboardingVia = '', onboardingSubType = '', isBSEEnabled, minorName = '' } = values;
    try {
      const response = (await dispatch(
        SendEmail({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          bypassOtp: true,
          kycMethod: kycMethod.selectedValue,
          dob: getFormattedISTDate(dob) ?? dob,
          name,
          accountType: "EXECUTIONARY",
          onboardingType,
          onboardingVia,
          onboardingSubType,
          isBSEEnabled,
          onboardingApplicationType: ONBOARDING_TYPE_MAPPER[onboardingType],
          minorName
        })
      )) as unknown as VerifyOtpResponseBody;

      if (!response) return

      const { applicantVerificationToken } = response || {};

      // if (id && redirectTo) {
      //   const res = (await dispatch(
      //     addJointHolder({ applicantVerificationToken }, id)
      //   )) as unknown as CreateApplicationProps;
      //   if (!res?.isSuccess) {
      //     dispatch(showError(res?.message as string));
      //     return;
      //   }
      //   history.push(redirectTo, { id });
      //   return;
      // }

      const res = (await dispatch(
        createApplication({ applicantVerificationToken })
      )) as unknown as CreateApplicationProps;

      if (!res) return

      if (!res?.isSuccess) {
        dispatch(showError((res?.message ?? "") as string));
        return;
      }

      if (res?.application?.applicationType === 'individual') {
        history.push('/application', { ...(res?.application || {}) });
      } else {
        history.push('/non-individual-application', { ...(res?.application ?? {}) });
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setCreateOnboarding(false);
    }

  };

  const handleClose = () => {
    setAmlPopup(null);
  };

  const handleDateChange = (fieldName: string, selectedDate: any, setFieldValue: any) => {
    setFieldValue(fieldName, getFormattedISTDate(selectedDate), true);
    // setFieldValue(fieldName, selectedDate?.isValid() ? selectedDate : "", true);
    setVerifyPanApiCalled(false);
    setpanVerificationToken('');
  }

  // aml popup submit function.
  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const { amlComments, amlAcknowledgement } = values;
      const { panVerificationToken = '', pan = '', dob = '' } = amlPopup || {};
      setAmlPopup(null);
      const response = (await dispatch(
        AcknowledgeAmlCheck({ panVerificationToken, amlComments, amlAcknowledgement })
      )) as unknown as AcknowledgeAmlCheckResponseBody;
      routingAfterPanVerification(response, pan, dob, formikRef?.current?.values?.onboardingVia ?? "");
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, resetForm, values, setFieldValue, errors, setValues }) => {
          const statusObject = values?.onboardingType === 'minor'
            ? minorOnboardingSubTypes
            : values?.onboardingType === 'nonIndividual'
              ? investorTypeMasters
              : personLDetailsStatusMasters;
          return (
            <>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                {/* <UseRadioGroup
                disabled={id ? true : false}
                formLabel="Investor Type*"
                name="onboardingType"
                items={Object.keys(onboardingTypeMasters).map((type) => ({
                  value: type,
                  label: onboardingTypeMasters[type],
                }))}
              /> */}
                <Typography variant='body_500' color="text.secondary">Investor Type</Typography>
                <Grid container mt={1} mb={3} spacing={1.5}>
                  {onboardingTypes
                    .filter(obj => !(
                      (isInvestorDiyOnboarding || isDiyJointHolder) &&
                      (obj.value === "minor" || obj.value === "nonIndividual")))
                    .map((
                      obj: {
                        label: string;
                        value: string;
                      }) =>
                      <Grid key={obj?.value} item>
                        <InvestorType
                          value={obj?.value}
                          label={obj?.label}
                          isDisabled={id ? true : false}
                          activeType={values?.onboardingType}
                          handleClick={() => {
                            // setFieldValue("onboardingType", obj?.value);
                            setVerifyPanApiCalled(false);
                            setValues({
                              ...values,
                              onboardingType: obj?.value,
                              onboardingSubType: obj?.value === "nonIndividual" ? "corporate" : "Individual",
                              kycMethod: {
                                selectedValue: obj?.value === "nonIndividual" ? 'osv' : 'investor',
                                isOsvOpen: obj?.value === "nonIndividual" ? true : false
                              }
                            })
                          }}
                        />
                      </Grid>
                    )}
                </Grid>
                {/* isOnboardingTypeMinor(values.onboardingType) */}
                {isOnboardingTypeMinor(values?.onboardingType) && (
                  <Box
                    // sx={{
                    //   '& .MuiSvgIcon-root': { display: 'none' },
                    //   '& .MuiTypography-root': { ml: 0 },
                    // }}
                    mt={2}
                    mb={2}
                  >
                    <Notes
                      displayContent={
                        'You have selected Minor Investor Onboarding. Please provide Guardian PAN and Date of Birth.'
                      }
                      showIcon={false}
                    />
                  </Box>
                )}

                <Grid container rowSpacing={2}>
                  <Grid item xs={12}>
                    {/* <UseRadioGroup
                    formLabel=""
                    name="onboardingSubType"
                    defaultValue={'normal'}
                    items={Object.keys(values?.onboardingType !== 'nonIndividual' ? ONBOARDING_SUB_TYPE_MINOR : ONBOARDING_SUB_TYPE_NON_INDIVIDUAL).map(obj => ({
                      label: values?.onboardingType !== 'nonIndividual' ? ONBOARDING_SUB_TYPE_MINOR[obj] : ONBOARDING_SUB_TYPE_NON_INDIVIDUAL[obj],
                      value: obj
                    }))}
                    onChange={(e) => {
                      setFieldValue("onboardingSubType", e.target.value);
                      setVerifyPanApiCalled(false);
                    }}
                  /> */}
                    <MFSelectField
                      name={`onboardingSubType`}
                      label="Onboarding Sub Type*"
                      items={Object.keys(statusObject).map((status) => ({
                        key: statusObject[status],
                        value: status,
                      }))}
                      disabled={false}
                    // onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                    //   setFieldValue(`onboardingSubType`, value);
                    // }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <UseRadioGroup
                      name="isBSEEnabled"
                      disabled={id ? true : false}
                      items={fundTypes}
                      onChange={(e) => handleFundTypeChange(e.target.value)}
                    />
                    <Tooltip title={values?.isBSEEnabled ? 'KRA verification is Mandatory and BSE account will be created' : 'KRA Verification is not required and BSE account will not be created'} followCursor>
                      <Typography variant='body_500' color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: '5px', ml: 1, mt: 1 }}><InfoIconOutlined />Note</Typography>
                    </Tooltip>
                  </Grid>
                  {isOnboardingTypeMinor(values?.onboardingType) && <Grid item xs={12}>
                    <MFTextField
                      label={'Minor Full Name*'}
                      name="minorName"
                      placeholder={'Minor Full Name*'}
                      required
                      autoComplete="off"
                      onChange={(e) => {
                        setFieldValue("minorName", e.target.value)
                        setVerifyPanApiCalled(false);
                        setpanVerificationToken('');
                      }}
                    />
                  </Grid>}
                  <Grid item xs={12}>
                    <MFTextField
                      label={`${isOnboardingTypeMinor(values?.onboardingType)
                        ? "Guardian Full Name"
                        : "Full Name"
                        }(as per PAN)*`}
                      name="name"
                      placeholder={isOnboardingTypeMinor(values?.onboardingType) ? 'Guardian Full Name*' : 'Full Name*'}
                      required
                      autoComplete="off"
                      onChange={(e) => {
                        setFieldValue("name", e.target.value)
                        setVerifyPanApiCalled(false);
                        setpanVerificationToken('');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      // label={isOnboardingTypeMinor(values.onboardingType) ? 'Guardian PAN' : 'PAN'}
                      label={isOnboardingTypeMinor(values?.onboardingType) ? `Guardian ${getUniqueIdentityText(company)?.panNumber}*` : `${getUniqueIdentityText(company)?.panNumber}*`}
                      name="pan"
                      placeholder={`${getUniqueIdentityText(company)?.pan}`}
                      required
                      autoComplete="off"
                      inputProps={{ style: { textTransform: 'uppercase' } }}
                      sx={{ mt: 0 }}
                      onChange={(e) => {
                        setFieldValue("pan", e.target.value);
                        setVerifyPanApiCalled(false);
                        setpanVerificationToken('');
                      }}
                      // endAdornment={
                      //   verifyPanApiCalled ? (
                      //     panVerificationResponse?.panAddharCheck && panVerificationResponse?.kraCheck ? (
                      //       <CheckCircleIcon sx={{ color: theme.palette.customColors.greenTeal }} />
                      //     ) : (
                      //       <CancelIcon sx={{ color: theme.palette.error[500] }} />
                      //     )
                      //   ) : <></>
                      // }
                      endAdornment={
                        (verifyPanApiCalled) ? (
                          (values?.onboardingType !== "nonIndividual" ? panVerificationResponse?.panAddharCheck : true) && panVerificationResponse?.kraCheck ? (
                            <CheckCircleIcon sx={{ color: theme.palette.customColors.greenTeal }} />
                          ) : (
                            <CancelIcon sx={{ color: theme.palette.error[500] }} />
                          )
                        ) : <></>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <TextDatePicker
                      name='dob'
                      label={isOnboardingTypeMinor(values?.onboardingType) ? 'Enter Guardian Date of Birth ( DD/MM/YYYY)*' : values?.onboardingType === 'nonIndividual' ? 'Date of Registration/Incorporation ( DD/MM/YYYY)*' : 'Date of Birth ( DD/MM/YYYY)*'}
                      placeholder=""
                      minDate={(values.onboardingType === 'nonIndividual' && values?.onboardingSubType !== 'SOLEPROP')
                        ? getDateValidation({ date: values?.dob, limitValue: yearfor156years }).dateLimitYearsAgo
                        : getDateValidation({ date: values?.dob, limitValue: yearfor125years }).dateLimitYearsAgo
                      }
                      maxDate={(values.onboardingType === 'nonIndividual' && values?.onboardingSubType !== 'SOLEPROP') ?
                        todaysdate() :
                        getDateValidation({ date: values?.dob, limitValue: eighteenYearsAgoDate }).dateLimitYearsAgo}
                      customHandleChange={(selectedDate: any) => handleDateChange('dob', selectedDate, setFieldValue)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: { sx: 'flex-start', md: 'flex-end ' }, alignSelf: 'flex-start' }}>
                    <LoadingButton variant='contained' loading={amlAcknowledgementLoading}
                      sx={{
                        color: 'textDark.primary',
                        backgroundColor: 'primary.500',
                        padding: "10px",
                        ...theme.typography.body_600,
                        marginTop: { xs: 0, md: '15px' }
                      }}
                      onClick={() => handleVerifyPan(values)}
                      disabled={verifyPanApiCalled}
                    >
                      Verify Pan
                    </LoadingButton>
                  </Grid>
                  {/* {values?.onboardingType !== 'nonIndividual' && 
                  (*/}
                  <Grid item xs={12}>
                    <VerifyPanAadharAmlKycSection checkStatus={{ amlCheck: panVerificationResponse?.amlCheck ?? false, ckycCheck: panVerificationResponse?.isCkycAvailable ?? false, panAddharCheck: panVerificationResponse?.panAddharCheck ?? false, kraCheck: panVerificationResponse?.kraCheck ?? false }} verifyPanApiCalled={verifyPanApiCalled} onboardingType={values?.onboardingType} />
                  </Grid>
                  {/* )
                } */}
                  <Grid item xs={12}>
                    <Typography variant='subtitle_600' sx={{ fontWeight: '500', color: theme.palette.text.secondary, mb: 1 }}>KYC Verification Method</Typography>
                    <KycOsvSection disabled={values?.onboardingType === 'nonIndividual' ? 'osv' : panVerificationResponse?.isCkycAvailable ? 'investor' : ''} setPanVerificationToken={setpanVerificationToken} />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      label={values.onboardingType === 'nonIndividual' ? 'Contact Person Mobile Number*' : 'Mobile Number*'}
                      name="mobile"
                      placeholder="Enter Mobile number"
                      onKeyDown={(e) => {
                        preventSpecialCharacters(e);
                      }}
                      startAdornment={
                        <CountryCodesDropDown
                          ElementWidth={mobileElementWidth && mobileElementWidth}
                          name={'countryNameAndCode'}
                          value={values.countryNameAndCode || ''}
                          disabled={values?.onboardingSubType === 'Individual' || values?.onboardingType === 'nonIndividual'}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      autoComplete="off"
                      label={values.onboardingType === 'nonIndividual' ? 'Contact Person Email ID*' : 'Email ID*'}
                      name="emailId"
                      placeholder='Email ID'
                      required
                    />
                  </Grid>
                </Grid>

                {/* {PHYSICAL_DIGITAL_FLOW && (!(isInvestorDiyOnboarding || isDiyJointHolder) && showRadioGroup && (
                <Grid item xs={12} pt={3} pb={1}>
                  <UseRadioGroup
                    formLabel=""
                    name="onboardingVia"
                    defaultValue="physical"
                    disabled={id ? true : false}
                    items={Object.keys(ONBOARDING_VIA_OPTIONS).map(obj => ({
                      label: ONBOARDING_VIA_OPTIONS[obj],
                      value: obj
                    }))}
                  />
                </Grid>
              ))
              } */}
                <Box mt={5} mb={3}>
                  {/* <MFSubmitButton label={` Verify ${getUniqueIdentityText(company)?.pan}`} loadingEnable={amlAcknowledgementLoading} /> */}
                  <MFSubmitButton label="Initiate Onboarding" disabled={!verifyPanApiCalled} loadingEnable={createOnboarding} />
                </Box>
                {/* {(currencyCode?.toLowerCase() === "inr") && (
                <Notes
                  displayContent={
                    // 'Add the applicant(s) PAN and if the PAN is KRA verified, the contact details will be populated automatically.'
                    'The PAN will be checked against World-Check database for AML compliance.'
                  }
                  icon={<InfoIconOutlined />}
                />
              )} */}
              </Box>
              <Dialog open={open} onClose={() => setOpen(false)}>
                <Box
                  sx={{
                    p: { xs: 2, sm: 8 },
                    borderRadius: '10px',
                    // width: { xs: '70%', sm: '70%' },
                    maxWidth: 800,
                    height: { xs: '90%', md: 'unset' },
                    overflowY: 'auto',
                  }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '& .MuiButton-root': {
                        minWidth: 200,
                        fontSize: 16,
                      },
                    }}>
                    <Box sx={{ mb: 8 }}>
                      <CardMedia
                        component="img"
                        src="/images/warning-icon-red.svg"
                        sx={{ width: 'unset' }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 20,
                        fontWeight: 500,
                        color: '#337FC9',
                        textAlign: 'center',
                        width: '70%',
                        mb: 5,
                      }}>
                      Unable to verify the details please contact admin
                    </Typography>
                    <Button
                      // component={RouterLink}
                      variant="contained"
                      onClick={() => {
                        resetForm();
                        setOpen(false);
                      }}
                      sx={{ color: 'common.white' }}>
                      Enter another PAN
                    </Button>
                  </Box>
                </Box>
              </Dialog>
              <Dialog
                open={kraPopup}
                maxWidth='sm'
                fullWidth
                sx={{
                  '& .MuiPaper-root': {
                    borderRadius: '15px',
                    backgroundColor: "background.paper",
                    rowGap: "15px",
                  },
                }}
              >
                <DialogContent sx={{ paddingTop: "25px" }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: '24px', height: '24px', mr: 2 }}
                    />
                    <Typography variant='h2' color="text.primary">KRA Verification Failed</Typography>
                  </Box>
                  <Typography variant='subtitle_400' color="text.secondary">
                    {`${panVerificationResponse?.kraMessage || 'Your KRA is not verified.'}`}
                  </Typography>
                  {/* <Typography variant='subtitle_400' color="text.secondary" mt={1}>
                  Please verify your KRA to continue with MF Funds application.
                </Typography> */}
                </DialogContent>
                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                  <Button
                    variant="outlined"
                    disabled={amlAcknowledgementLoading}
                    onClick={handleKraPopupClose}
                    sx={(theme: Theme) => ({
                      ...theme.typography.body_500,
                      color: theme.palette.text.secondary,
                      flex: 1,
                      border: `0.5px solid ${theme.palette.text.secondary}`,
                      padding: "10px",
                      "&:hover, &.Mui-focusVisible": {
                        borderColor: theme.palette.text.secondary,
                        backgroundColor: theme.palette.background.default
                      }
                    })}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    disabled={amlAcknowledgementLoading}
                    sx={(theme: Theme) => ({
                      ...theme.typography.body_500,
                      flex: 1,
                      color: theme.palette.textDark.primary,
                      padding: "10px"
                    })}
                    onClick={onKraSubmit}
                  >
                    Continue
                  </Button>
                </DialogActions>
              </Dialog>

              <AmlPopup
                handleClose={handleClose}
                amlPopupOpen={amlPopup !== null}
                onSubmit={onSubmit}
                FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
                EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
                displayDocInfo={true}
              />
            </>
          )
        }
        }
      </Formik >
    </>
  );
}

export function EnterMobile({
  location,
}: {
  location: Location<{
    redirectTo: string;
    panVerificationToken: string;
    pan: string;
    firstHolderName: string;
    application: ApplicationProps;
    dob: string;
    amlCheck: boolean;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    panVerificationToken,
    pan,
    firstHolderName = '',
    application,
    dob,
    amlCheck = false,
  } = location.state || {};
  const theme = useTheme()
  const { path: currentPathName } = useRouteMatch();

  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  const [applicationTypes, setApplicationTypes] = useState<{
    code: string;
    description: string;
  }[]>([])
  const [isApplicationTypesLoading, setApplicationTypesLoading] = useState<boolean>(false)
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);

  const isInvestorDiyOnboarding = currentPathName === '/investor-onboarding/enter-mobile-number'
  const isDiyJointHolder = currentPathName.includes('add-diy-joint-holder')

  const validationSchema1 = (id: string) => yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      // .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }
        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }

          if (!nonIndividualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }
        }
        return true;
      }),
    emailId: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path, parent } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => (disablePOA ? true : !value),
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
    accountType: yup
      .string()
      .test('is-required', (value, context) => {
        const { path, createError } = context;
        if (id) {
          return true
        } else {
          if (!value) {
            return createError({
              message: 'Please select an account type',
              path,
            });
          }
          return true
        }
      }),
  })
  const initialValues1: MValues = {
    pan: pan,
    mobile: '',
    emailId: '',
    bypassOtp: false,
    skipOtpModal: false,
    hasPOA: false,
    dob: dob,
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    onboardingOtpEmailConsent: 'otp',
    accountType: id
      ? ""
      : (isInvestorDiyOnboarding)
        ? "EXECUTIONARY"
        : applicationTypes?.[0]?.code ?? ""
  };

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as CreateApplicationProps;
    if (!res?.isSuccess) {
      dispatch(showError(res?.message as string));
      return;
    }
    history.push('/application/rm-details', { ...(res?.application || {}) });
  };

  const handleSubmit1 = async (values: MValues) => {
    try {

      const {
        pan,
        mobile = '',
        bypassOtp = false,
        hasPOA,
        emailId,
        countryCode = '+91',
        countryNameAndCode = 'India: +91',
        onboardingOtpEmailConsent = 'otp',
        accountType = ""
      } = values;
      if (hasPOA) {
        const poaResponse = (await dispatch(
          EnablePOA({ panVerificationToken, powerOfAttorney: true })
        )) as unknown as EnablePOAResponseBody;

        if (!poaResponse) return

        const { applicantVerificationToken } = poaResponse;
        await handleCreateApplication(applicantVerificationToken);
        return;
      }
      if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
        const sendConsentEmailResponse = (await dispatch(
          sendConsentEmail({
            phoneNumber: mobile.trim(),
            emailId,
            panVerificationToken,
            countryCode: countryNameAndCode?.split(':')[1].trim(),
            countryNameAndCode,
            applicationId: id || '',
            accountType
          })
        )) as unknown as SendConsentEmailResponseBody;

        if (!sendConsentEmailResponse) return

        enqueueSnackbar('Email sent successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
        return history.push(
          [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
            ? `/applications-list`
            : '/applications'
        );
      }

      const sendOtpResponse = (await dispatch(
        sendOtp({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          bypassOtp,
          // ...((isInvestorDiyOnboarding || isDiyJointHolder) ?
          //   {
          //     accountType: isDiyJointHolder ? "" : "EXECUTIONARY"
          //   } : { accountType })
          accountType
        }, (isInvestorDiyOnboarding || isDiyJointHolder))
      )) as unknown as SendOtpResponseBody;

      if (!sendOtpResponse) return

      const { applicantVerificationToken, phoneNumber } = sendOtpResponse || {};

      if (bypassOtp) {
        if (id && redirectTo) {
          const res = (await dispatch(
            addJointHolder({ applicantVerificationToken }, id)
          )) as unknown as CreateApplicationProps;
          if (!res?.isSuccess) {
            dispatch(showError(res?.message as string));
            return;
          }
          history.push(redirectTo, { id });
          return;
        }
        handleCreateApplication(applicantVerificationToken);
        return;
      }

      history.push('enter-otp', {
        pan,
        unmaskedphone: mobile.trim(),
        umaskedemailId: emailId,
        mobile: phoneNumber,
        panVerificationToken,
        redirectTo,
        application,
        email: (sendOtpResponse || {}).emailId,
        firstHolderName,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
        accountType,
        ...(sendOtpResponse || {}),
      });

    } catch (error) {
      console.log("Error: ", error)
    }
  };

  // useEffect(() => {
  //   (async function () {
  //     const res = (await dispatch(
  //       IsApplicableForPOA()
  //     )) as unknown as IsApplicableForPOAResponseBody;
  //     const { powerOfAttorney } = res;
  //     setDisablePOA(
  //       application
  //         ? application.hasPOA
  //           ? application.hasPOA
  //           : !application.hasPOA
  //         : !powerOfAttorney
  //     );
  //   })();
  // }, []);
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const fetchApplicationTypes = async () => {
      if (isInvestorDiyOnboarding || isDiyJointHolder) {
        return
      }

      try {
        setApplicationTypesLoading(true)

        const response = await (dispatch(getApplicationTypes()) as unknown as Promise<{ code: string; description: string }[]>)

        setApplicationTypes(response ?? [])
      } catch (error) {
        console.log(error)
      } finally {
        setApplicationTypesLoading(false)
      }
    }

    fetchApplicationTypes()
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1(id)}
        onSubmit={handleSubmit1}
        enableReinitialize={true}
      >
        {({
          handleSubmit,
          values,
          validateForm,
          isSubmitting,
          setTouched,
          setErrors,
          setFieldValue,
        }) => (
          (
            <>
              <Grid container component="form" noValidate onSubmit={handleSubmit}>
                {/* <Box sx={{ position: 'relative' }}> */}
                {/* <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                  <CardMedia
                    component="img"
                    src="/images/tick.svg"
                    sx={{ width: '18px', float: 'right' }}
                  />
                  </Box> */}
                <Grid item container xs={12} mb={1}>
                  <MFTextField
                    label="PAN Number"
                    name="pan"
                    placeholder="Enter PAN"
                    required
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    disabled={true}
                    applyMarginBottom={false}
                    endAdornment={
                      <InputAdornment position="end">
                        <TickIcon fillColor={theme.palette.success[500]} />
                      </InputAdornment>
                    }
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: 'success.500', mb: 0.5 }}>
                    {ONBOARDING_KYC_VERIFIED_MESSAGE ? `KYC Verified,${' '}` : ''}
                    <Typography
                      variant="body2"
                      component={'span'}
                      sx={{
                        fontWeight: 600,
                        color: amlCheck ? 'success.500' : 'error.500',
                        mb: 0.5,
                      }}>
                      AML Check {amlCheck ? 'Passed' : 'Failed'}
                    </Typography>
                  </Typography>
                </Grid>
                {IS_DOB_APPLICABLE_FOR_AMC && (
                  <Grid item xs={12}>
                    <TextDatePicker
                      label={'Date of Birth'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: `${theme.palette.common.black}B3`
                      }}
                      placeholder={'Enter Date of Birth'}
                      name="dob"
                      disabled={true}
                      minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                    />
                  </Grid>
                )}

                {/* <MFCheckbox
                  name="hasPOA"
                  label="Power of Attorney"
                  color="primary"
                  sx={{
                    '.MuiTypography-root': {
                      color: 'primary.main',
                      fontWeight: 500,
                      fontSize: 14,
                      letterSpacing: '0.9625px',
                    },
                  }}
                  disabled={disablePOA}
                /> */}
                {!values.hasPOA && (
                  <>
                    <Grid item xs={12}>
                      <MFTextField
                        label="Mobile Number"
                        name="mobile"
                        placeholder="Enter Mobile number"
                        onKeyDown={(e) => {
                          preventSpecialCharacters(e);
                        }}
                        startAdornment={
                          <CountryCodesDropDown
                            ElementWidth={mobileElementWidth && mobileElementWidth}
                            name={'countryNameAndCode'}
                            value={values.countryNameAndCode}
                          />
                        }
                      />
                    </Grid>
                    {ENABLE_EMAIL_OTP && (
                      <Grid item xs={12}>
                        <MFTextField
                          autoComplete="off"
                          // autoFocus
                          label="Email ID"
                          name="emailId"
                          placeholder="Enter Email ID"
                          required
                        />
                      </Grid>
                    )}
                    {ENABLE_Email_Consent && (
                      <Grid item xs={12} pt={3} pb={1}>
                        <UseRadioGroup
                          formLabel=""
                          name={`onboardingOtpEmailConsent`}
                          defaultValue="otp"
                          items={Object.keys(ONBOARDING_OPTIONS)
                            .filter(type => !((isInvestorDiyOnboarding || isDiyJointHolder) && type === 'email_consent'))
                            .map((option) => ({
                              label: ONBOARDING_OPTIONS[option],
                              value: option,
                            }))}
                        />
                      </Grid>
                    )}
                    {!(isInvestorDiyOnboarding || isDiyJointHolder) && (
                      <>
                        {isApplicationTypesLoading && (
                          <Grid
                            item
                            container
                            pt={3}
                            pb={1}
                            spacing={2}
                            flexWrap={{ xs: "wrap", lg: "nowrap" }}
                          >
                            {[...Array(3)].map((_, index) => (
                              <Grid
                                item
                                key={index}
                                width="100%"
                              >
                                <Skeleton
                                  animation="wave"
                                  variant="rounded"
                                  height={45}
                                  width="100%"
                                />
                              </Grid>
                            ))}
                          </Grid>
                        )}
                        {!isApplicationTypesLoading && (
                          <Grid item xs={12} pt={3} pb={1}>
                            <UseRadioGroup
                              formLabel=""
                              name="accountType"
                              disabled={id ? true : false}
                              items={applicationTypes.map(obj => ({
                                label: obj?.description ?? "",
                                value: obj?.code ?? ""
                              }))}
                            />
                          </Grid>
                        )}
                      </>
                    )}
                    <Grid item xs={12} py={2}>
                      <Notes
                        displayContent={
                          // 'Provide the mobile number which is registered in KRA database. Applicants Identity details will be fetched from the KRA database.'
                          'This mobile number and email id will be used for all future communication related to this investment.'
                        }
                        icon={<InfoIconOutlined />}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} py={2}>
                  <MFSubmitButton
                    disabled={isSubmitting || isApplicationTypesLoading}
                    label={
                      values.hasPOA
                        ? 'Continue'
                        : ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                          ONBOARDING_OPTIONS.email_consent
                          ? 'Send Email'
                          : 'Get OTP'
                    }
                  />
                </Grid>
                {!(isInvestorDiyOnboarding || isDiyJointHolder) &&
                  !values.hasPOA &&
                  ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                  ONBOARDING_OPTIONS.otp && (
                    <Grid item xs={12} py={1}>
                      <Button
                        variant="outlined"
                        fullWidth
                        sx={{
                          color: 'text.secondary',
                          backgroundColor: "transparent",
                          borderWidth: "0.5px",
                          borderStyle: "solid",
                          borderColor: "text.secondary",
                          padding: "10px",
                          "&:hover, &.Mui-focusVisible": { borderColor: 'text.secondary', backgroundColor: "background.default" }
                        }}
                        disabled={isSubmitting || isApplicationTypesLoading}
                        onClick={async () => {
                          const error = await validateForm();
                          if (Object.keys(error).length) {
                            setTouched(setNestedObjectValues(error, true));
                            setErrors(error);
                            return;
                          }
                          setFieldValue('skipOtpModal', true);
                        }}>
                        Skip OTP Verification
                      </Button>
                    </Grid>
                  )}
              </Grid>
              <Dialog
                open={values.skipOtpModal}
                onClose={() => setFieldValue('skipOtpModal', false)}
                maxWidth='sm'
                fullWidth
                sx={{
                  '& .MuiPaper-root': {
                    borderRadius: '15px',
                    backgroundColor: "background.paper",
                    rowGap: "15px",
                  },
                }}
              >
                <DialogContent sx={{ paddingTop: "25px" }}>
                  <Typography variant='h2' color="text.primary" mb="10px">Skip OTP Verification</Typography>
                  <Typography variant='subtitle_400' color="text.secondary">Are you sure you want to skip OTP verification?</Typography>
                </DialogContent>
                <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
                  <Button
                    variant="outlined"
                    disabled={isSubmitting}
                    onClick={() => setFieldValue('skipOtpModal', false)}
                    sx={(theme: Theme) => ({
                      color: theme.palette.text.secondary,
                      flex: 1,
                      border: `0.5px solid ${theme.palette.text.secondary}`,
                      padding: "10px",
                      "&:hover, &.Mui-focusVisible": {
                        borderColor: theme.palette.text.secondary,
                        backgroundColor: theme.palette.background.default
                      }
                    })}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    sx={(theme: Theme) => ({
                      flex: 1,
                      color: theme.palette.textDark.primary,
                      padding: "10px"
                    })}
                    onClick={() => {
                      setFieldValue('bypassOtp', true);
                      handleSubmit();
                      setFieldValue('skipOtpModal', false);
                    }}>
                    Continue
                  </Button>
                </DialogActions>
                {/* <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 3,
                      '& .MuiButton-root': {
                        minWidth: 200,
                        fontSize: 16,
                      },
                    }}> */}
                {/* <IconButton
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ alignSelf: 'flex-end' }}>
                      <CloseIcon fontSize="small" />
                    </IconButton> */}
                {/* <Box sx={{ mb: 4 }}>
                      <CardMedia
                        component="img"
                        src="/images/warning-icon-red.svg"
                        sx={{ width: 'unset' }}
                      />
                    </Box> */}
                {/* <Typography
                      sx={{
                        fontSize: 20,
                        fontWeight: 500,
                        color: '#337FC9',
                        textAlign: 'center',
                        mb: 5,
                        width: '90%',
                      }}>
                      Are you sure you want to Skip OTP Verification?
                    </Typography> */}
                {/* <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'space-around',
                      width: '100%',
                    }}>
                    <Button
                      variant="outlined"
                      disabled={isSubmitting}
                      onClick={() => setFieldValue('skipOtpModal', false)}
                      sx={{ color: 'primary.main', mb: 2 }}>
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ mb: 2 }}
                      onClick={() => {
                        setFieldValue('bypassOtp', true);
                        handleSubmit();
                        setFieldValue('skipOtpModal', false);
                      }}>
                      Continue
                    </Button>
                  </Box> */}
                {/* </Box> */}
              </Dialog>
            </>
          )
        )
        }
      </Formik >
    </>
  );
}

export function EnterEmailId({
  location,
}: {
  location: Location<{
    panVerificationToken: string;
    pan: string;
    dob: string;
    amlCheck: boolean;
    application: ApplicationProps;
    onboardingVia?: string;
    redirectTo?: string;
    onboardingType?: string;
  }>;
}): JSX.Element {
  const theme = useTheme()
  const { panVerificationToken, pan, dob, amlCheck = false, application, onboardingVia, redirectTo, onboardingType } = location.state || {};
  const { id } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const { company = "WMS" } = useSelector((store: RootStateType) => store.navbarInfo)
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);

  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  const [isApplicationTypesLoading, setApplicationTypesLoading] = useState<boolean>(false)
  const [applicationTypes, setApplicationTypes] = useState<{
    code: string;
    description: string;
  }[]>([])

  useEffect(() => {
    const fetchApplicationTypes = async () => {
      try {
        setApplicationTypesLoading(true)

        const response = await (dispatch(getApplicationTypes()) as unknown as Promise<{ code: string; description: string }[]>)

        setApplicationTypes(response ?? [])
      } catch (error) {
        console.log(error)
      } finally {
        setApplicationTypesLoading(false)
      }
    }

    fetchApplicationTypes()
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, [])

  const validationSchema1 = (id: string) => yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      // .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: `${getUniqueIdentityText(company)?.pan} is required`,
            path,
          });
        }

        if (currencyCode?.toLowerCase() === "inr") {
          if (fieldValue?.length !== 10) {
            return createError({
              message: 'PAN must be exactly 10 characters',
              path,
            });
          }

          if (fieldValue.split('')[3] === 'P' && !individualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }

          if (!nonIndividualPanRegex.test(fieldValue)) {
            return createError({
              message: 'invalid PAN',
              path,
            });
          }
        }

        return true;
      }),

    emailId: yup
      .string()
      .nullable()
      .matches(emailRegex, 'invalid Email ID')
      .required('Email is required'),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => !value,
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => !value,
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
    accountType: yup
      .string()
      .test('is-required', (value, context) => {
        const { path, createError } = context;
        if (id) {
          return true
        } else {
          if (!value) {
            return createError({
              message: 'Please select an account type',
              path,
            });
          }
          return true
        }
      }),
  });

  const initialValues1: EValues = {
    pan: pan,
    emailId: '',
    mobile: '',
    countryNameAndCode: 'India: +91',
    dob: dob,
    accountType: id ? "" : applicationTypes?.[0]?.code ?? ""
  };

  const handleSubmit1 = async (values: EValues) => {
    const { emailId, mobile, countryNameAndCode, accountType } = values;
    const response = (onboardingVia === 'physical')
      ? (await dispatch(
        physicalOnboarding({
          panVerificationToken,
          emailId,
          phoneNumber: mobile.trim(),
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          accountType
        })
      )) as unknown as VerifyOtpResponseBody
      :
      (await dispatch(
        SendEmail({
          panVerificationToken,
          emailId,
          phoneNumber: mobile.trim(),
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          bypassOtp: true,
          accountType
        })
      )) as unknown as VerifyOtpResponseBody;

    if (!response) return

    const { applicantVerificationToken } = response || {};

    if (id && redirectTo) {
      const res = (await dispatch(
        addJointHolder({ applicantVerificationToken }, id)
      )) as unknown as CreateApplicationProps;
      if (!res?.isSuccess) {
        dispatch(showError(res?.message as string));
        return;
      }
      history.push(redirectTo, { id });
      return;
    }


    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as CreateApplicationProps;

    if (!res) return

    if (!res?.isSuccess) {
      dispatch(showError((res?.message ?? "") as string));
      return;
    }

    if (onboardingVia === 'physical' && res?.application?.applicationType === 'individual') {
      history.push('/application', { ...(res?.application || {}) });
    } else {
      history.push('/non-individual-application', { ...(res?.application ?? {}) });
    }
    // history.push('verify-documents', {
    //   applicantVerificationToken,
    // });
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1(id)}
        onSubmit={handleSubmit1}
        enableReinitialize={true}
      >
        {({ values, handleSubmit, isSubmitting }) => (
          <Grid container component="form" noValidate onSubmit={handleSubmit}>
            {/* <Box sx={{ position: 'relative' }}>
            </Box> */}
            {/* <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                <CardMedia
                  component="img"
                  src="/images/tick.svg"
                  sx={{ width: '18px', float: 'right' }}
                />
              </Box> */}
            <Grid item container xs={12} mb={1}>
              <MFTextField
                label="PAN"
                name="pan"
                placeholder="Enter PAN"
                required
                inputProps={{ style: { textTransform: 'uppercase' } }}
                disabled={true}
                applyMarginBottom={false}
                endAdornment={
                  <InputAdornment position="end">
                    <TickIcon fillColor={theme.palette.success[500]} />
                  </InputAdornment>
                }
              />
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: 'success.500', mb: 0.5 }}>
                {ONBOARDING_KYC_VERIFIED_MESSAGE ? `KYC Verified,${' '}` : ''}
                <Typography
                  variant="body2"
                  component={'span'}
                  sx={{
                    fontWeight: 600,
                    color: amlCheck ? 'success.500' : 'error.500',
                    mb: 0.5,
                  }}>
                  AML Check {amlCheck ? 'Passed' : 'Failed'}
                </Typography>
              </Typography>
            </Grid>
            {IS_DOB_APPLICABLE_FOR_AMC && (
              <Grid item xs={12}>
                <TextDatePicker
                  label={'Date of Birth/Incorporation'}
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'Enter Date of Birth'}
                  name="dob"
                  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                  disabled={true}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <MFTextField
                label={`${(onboardingType === 'individual' && onboardingVia === 'physical') ? 'Mobile Number' : 'Contact Person Mobile Number'}`}
                name="mobile"
                placeholder="Enter Mobile number"
                onKeyDown={(e) => {
                  preventSpecialCharacters(e);
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset>legend": {
                      fontSize: { xs: "0.6em", md: "0.81em", lg: "0.8em" }
                    }
                  }
                }}
                startAdornment={
                  <CountryCodesDropDown
                    ElementWidth={mobileElementWidth && mobileElementWidth}
                    name={'countryNameAndCode'}
                    value={values.countryNameAndCode}
                  />
                }
                disabled={isSubmitting || isApplicationTypesLoading}
              />
            </Grid>
            <Grid item xs={12}>
              <MFTextField
                autoComplete="off"
                label={`${(onboardingType === 'individual' && onboardingVia === 'physical') ? 'Email ID' : 'Contact Person Email ID'}`}
                name="emailId"
                placeholder={`${(onboardingType === 'individual' && onboardingVia === 'physical') ? 'Email ID' : 'Contact Person Email ID'}`}
                required
                disabled={isSubmitting || isApplicationTypesLoading}
              />
            </Grid>
            {isApplicationTypesLoading && (
              <Grid
                item
                container
                pt={3}
                pb={1}
                spacing={2}
                flexWrap={{ xs: "wrap", lg: "nowrap" }}
              >
                {[...Array(3)].map((_, index) => (
                  <Grid
                    item
                    key={index}
                    width="100%"
                  >
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      height={45}
                      width="100%"
                    />
                  </Grid>
                ))}
              </Grid>
            )}
            {!isApplicationTypesLoading && (
              <Grid item xs={12} pt={3} pb={1}>
                <UseRadioGroup
                  formLabel=""
                  name="accountType"
                  disabled={(id || isSubmitting) ? true : false}
                  items={applicationTypes.map(obj => ({
                    label: obj?.description ?? "",
                    value: obj?.code ?? ""
                  }))}
                />
              </Grid>
            )}
            <Grid item xs={12} py={2}>
              <Notes
                displayContent={
                  // 'Based on registered email id, we will fetch the documents available with our MF holding that are serviced by kfintech and the data will be prefilled in the application.'
                  'This mobile number and email id will be used for all future communication related to this investment.'
                }
              />
            </Grid>
            <MFSubmitButton
              disabled={isApplicationTypesLoading}
              loadingEnable={isSubmitting}
              label={'Proceed'}
            />
          </Grid>
        )}
      </Formik>
    </>
  );
}
